import React, { useEffect, useState } from "react";
import { LoadingButton } from "../../global/components/buttons/loading-button";
import { Textbox } from "../../global/components/inputs/textbox/textbox";
import { LoadingSpinner } from "../../global/components/loading-spinner";
import { IEpiProps, ISearchResultsContainer, SearchContext } from "../models/vertex-search-page-models";
import { useVertexSearchContext, useVertexSearchDispatch } from "../reducers/vertex-search-page-provider";
import { SearchAnswer } from "./search-answer";
import { SearchResult } from "./search-result";

interface IProps {
    isLoading: boolean
    isLoadingMoreResults: boolean
    onLoadMore: () => void;
    onRelatedQuestionClick: (relatedQuestion: string) => void;
}

interface IContextProps {
    epiProps: IEpiProps
    currentSearchContext: string
    searchResultsContainer: ISearchResultsContainer
    currentSearchQuery: string
}

export const SearchResultsAllAap = (props: IProps) => {
    const { epiProps, currentSearchContext, searchResultsContainer, currentSearchQuery }: IContextProps = useVertexSearchContext();

    return (
        <div>
            {
                searchResultsContainer?.searchResults?.length > 0 && !props.isLoading &&
                <React.Fragment>
                    <SearchAnswer onRelatedQuestionClick={props.onRelatedQuestionClick} />
                    {searchResultsContainer.searchResults.map(result => <SearchResult searchResult={result} />)}
                        {searchResultsContainer.nextPageToken && searchResultsContainer.nextPageToken.length > 0 &&
                            <LoadingButton
                                id={'vertex-load-more'}
                                buttonText={epiProps.loadMoreCtaText}
                                onClick={props.onLoadMore}
                                isLoading={props.isLoadingMoreResults}
                                customClasses='button-secondary vertex-search-load-button'
                            />
                        }
                </React.Fragment>

            }
            {
                currentSearchQuery.length > 1 && !props.isLoading &&
                (searchResultsContainer == null || searchResultsContainer?.searchResults == null || searchResultsContainer?.searchResults?.length == 0)
                && <p><span dangerouslySetInnerHTML={{ __html: epiProps.noSearchResultsText }}></span></p>
            }
        </div>
    )
}